<template>
  <section class="assessment-mode-placeholder">
    <div class="assessment-mode-placeholder__panel">
      <span class="assessment-mode-placeholder__icon-shell">
        <v-icon class="assessment-mode-placeholder__icon">
          {{ icon }}
        </v-icon>
      </span>

      <h1 class="assessment-mode-placeholder__title">
        {{ title }}
      </h1>

      <p class="assessment-mode-placeholder__description">
        {{ description }}
      </p>

      <span
        v-if="badgeText"
        class="assessment-mode-placeholder__badge"
      >
        <v-icon class="assessment-mode-placeholder__badge-icon">
          {{ mdiClockOutline }}
        </v-icon>
        <span>{{ badgeText }}</span>
      </span>

      <v-btn
        class="assessment-mode-placeholder__back-btn"
        @click="goBack"
      >
        {{ $t('app.assessment_mode.coming_soon.back') }}
      </v-btn>
    </div>
  </section>
</template>

<script>
import { mdiClockOutline } from '@mdi/js'

export default {
  name: 'AssessmentModePlaceholder',
  props: {
    badgeText: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      mdiClockOutline,
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
  },
}
</script>

<style scoped>
.assessment-mode-placeholder {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: calc(100vh - 220px);
  padding: 36px 20px 64px;
  box-sizing: border-box;
}

.assessment-mode-placeholder__panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(100%, 720px);
  margin: 0 auto;
  text-align: center;
}

.assessment-mode-placeholder__icon-shell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-bottom: 18px;
  border-radius: 50%;
  background: rgba(0, 124, 115, 0.14);
}

.assessment-mode-placeholder__icon {
  color: #007c73;
  font-size: 32px;
}

.assessment-mode-placeholder__title {
  margin: 0 0 10px;
  color: #173149;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
}

.assessment-mode-placeholder__description {
  margin: 0 0 18px;
  color: rgba(23, 49, 73, 0.62);
  font-size: 1.1rem;
  line-height: 1.45;
}

.assessment-mode-placeholder__badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border-radius: 999px;
  background: rgba(0, 124, 115, 0.16);
  color: #007c73;
  font-size: 0.95rem;
  font-weight: 700;
  line-height: 1;
}

.assessment-mode-placeholder__badge-icon {
  color: #007c73;
  font-size: 16px;
}

.assessment-mode-placeholder__back-btn {
  margin-top: 24px;
  background-color: var(--v-primaryblue-base, #003644) !important;
  color: #ffffff !important;
  box-shadow: none !important;
}

@media screen and (max-width: 600px) {
  .assessment-mode-placeholder {
    min-height: calc(100vh - 180px);
    padding: 24px 16px 40px;
  }

  .assessment-mode-placeholder__title {
    font-size: 1.7rem;
  }

  .assessment-mode-placeholder__description {
    font-size: 1rem;
  }
}
</style>
